import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';

export default function ToastHost({ toasts, onDismiss }) {
  return (
    <div className="toast-host" aria-live="polite" aria-relevant="additions removals">
      <AnimatePresence>
        {toasts.map((t) => (
          <motion.div
            key={t.id}
            className={`toast toast--${t.type}`}
            initial={{ opacity: 0, y: 12, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.98 }}
            transition={{ duration: 0.2 }}
          >
            <div className="toast__title">{t.title}</div>
            {t.message ? <div className="toast__message">{t.message}</div> : null}
            <button className="toast__close" type="button" onClick={() => onDismiss(t.id)} aria-label="Dismiss">
              ✕
            </button>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}

